import React from 'react';
import PropTypes from 'prop-types';
import { ShoppingCart } from 'tabler-icons-react';
import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppCard from '../../common/AppCard';
import { useMediaQueries } from '../../../helpers/hooks';
import CheckoutRegCartLineItem from './CheckoutRegCartLineItem';
import AppFlexbox from '../../common/AppFlexbox';
import WsCheckoutLineItem from '../ecommerce/webstore/sections/checkoutContent/WsCheckoutLineItem';
import { useCartLineItemDetails } from '../../../helpers/shop/useCartController';

const CheckoutItemList = ({
  regCart,
  loading,
  isDisabled,
  isCheckoutSubmitting,
  onCustomizeProduct,
  onRemoveCartProducts,
  onUpdateCartProducts,
  onRedeemCoupon,
  onRemoveUnavailableProducts
}) => {
  const { isLaptopOrSmaller, isTabletOrSmaller } = useMediaQueries();
  const { lineItems: checkoutLineItemsInfo } = useCartLineItemDetails(
    regCart?.ecomStoreCart
      ? { ...regCart.ecomStoreCart, checkoutCart: regCart.cart }
      : null
  );

  return (
    <AppStack
      style={{
        flex: 2,
        gap: isLaptopOrSmaller ? 10 : 20,
        alignSelf: 'stretch'
      }}
    >
      {loading && !regCart ? (
        <>
          <WsCheckoutLineItem footerButton={<></>} showFooter />
          <WsCheckoutLineItem footerButton={<></>} showFooter />
        </>
      ) : regCart.cart.lineItems.length === 0 ? (
        <AppFlexbox>
          <AppCard
            radius={isTabletOrSmaller ? 0 : 'md'}
            shadow="lg"
            style={{ flex: 1, padding: 32 }}
            withBorder
          >
            <AppFlexbox
              style={{
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <ShoppingCart color="#000" size={80} />
              <AppStack style={{ gap: 5 }}>
                <AppText style={{ fontSize: 20, fontWeight: 500 }}>
                  Your cart is empty.
                </AppText>
                <Button
                  color="dark"
                  component={Link}
                  style={{ marginTop: 5 }}
                  to="/leagues"
                  variant="outline"
                >
                  View associations
                </Button>
              </AppStack>
            </AppFlexbox>
          </AppCard>
        </AppFlexbox>
      ) : (
        regCart.cart.lineItems
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .map((i) => (
            <CheckoutRegCartLineItem
              key={`${i.entityId}-${i.serviceType}`}
              checkoutLineItemsInfo={checkoutLineItemsInfo}
              lineItem={i}
              onCustomize={onCustomizeProduct}
              onRedeemCoupon={onRedeemCoupon}
              onRemoveCartProducts={onRemoveCartProducts}
              onRemoveUnavailableProducts={onRemoveUnavailableProducts}
              onUpdateCartProducts={onUpdateCartProducts}
              regCart={regCart}
              submitting={isCheckoutSubmitting}
            />
          ))
      )}
    </AppStack>
  );
};

CheckoutItemList.propTypes = {
  isCheckoutSubmitting: PropTypes.bool,
  isDisabled: PropTypes.bool,
  loading: PropTypes.bool,
  onCustomizeProduct: PropTypes.func,
  onRedeemCoupon: PropTypes.func,
  onRemoveCartProducts: PropTypes.func,
  onRemoveUnavailableProducts: PropTypes.func,
  onUpdateCartProducts: PropTypes.func,
  regCart: PropTypes.object
};

export default CheckoutItemList;
